import { TableCell as Cell, Checkbox, TableRow as Row } from "semantic-ui-react";

type TableCellProps = {
  value?: string | null;
  checked?: boolean;
  disabled?: boolean;
  onToggle?: () => void;
};

type TableRowProps = {
  label: string;
  rows: TableCellProps[];
  currentValue?: string;
};

export const TableRow = ({ label, rows, currentValue }: TableRowProps) => (
  <Row>
    <Cell>{label}</Cell>
    <Cell>{currentValue || ""}</Cell>
    {rows.map((row, idx) => (
      <Cell key={idx}>
        {row.value && (
          <div className="checkbox-wrapper">
            <Checkbox checked={row.checked} onChange={row.onToggle} disabled={row.disabled} />
            <span>{row.value}</span>
          </div>
        )}
      </Cell>
    ))}
  </Row>
);
